module.exports = __webpack_public_path__ + "img/icon_list_download_selected.f2d77c94.svg";